import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const RedirectToWeb = () => {
  const { id } = useParams();

  useEffect(() => {
    window.location.replace(
      `https://app.mgherp.com${window.location.pathname}`
    );
  }, []);

  return "Redirecting...";
};

export default RedirectToWeb;
